export const defaultContext = `<%= question.topic.reteyner.name %> - <%= question.topic.text %>`;
